/** @format */

export const getBreakpoint = () => {
  if (window.innerWidth >= 1920) return 'xxl'; // 1920 -
  if (window.innerWidth >= 1440) return 'xl'; // 1440 - 1919
  if (window.innerWidth >= 1024) return 'lg'; // 1024 - 1439
  if (window.innerWidth >= 768) return 'md'; // 768 - 1023
  if (window.innerWidth >= 576) return 'sm'; // 576 - 767
  if (window.innerWidth >= 375) return 'xs'; // 375 - 575
  return 'xs'; // 0 - 375
};

const commonSize = (breakpoint, item) => {
  if (breakpoint === 'md')
    return {
      w: (item.w > 6 ? 2 : 1) || 1,
      h: 6,
      minW: 1,
      maxW: 2,
      minH: 3,
      maxH: 9
    };
  if (breakpoint === 'sm') return { w: 1, h: 6, minW: 1, maxW: 1, minH: 3, maxH: 9 };
  if (breakpoint === 'xs') return { w: 1, h: 6, minW: 1, maxW: 1, minH: 3, maxH: 9 };
};

export const calcSize = (size, item) => {
  const breakpoint = getBreakpoint();
  switch (size) {
    case 'small':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 3, h: 3, minW: 1, maxW: 4, minH: 3, maxH: 3 };
      }
      return { w: 1, h: 3, minW: 1, maxW: 2, minH: 2, maxH: 3 };
    case 'normal':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 3, h: 6, minW: 1, maxW: 9, minH: 3, maxH: 9 };
      }
      return commonSize(breakpoint, item);
    case 'wide':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 8, h: 6, minW: 1, maxW: 8, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
    case 'medium':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 4, h: 6, minW: 1, maxW: 8, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
    case 'large':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 6, h: 6, minW: 1, maxW: 8, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
    case 'xwide':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 10, h: 6, minW: 1, maxW: 10, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
    case '2xl':
    case 'fullWidth':
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        if (item.type === 'information') {
          return { w: 12, h: 4, minW: 1, maxW: 12, minH: 1, maxH: 7 };
        }
        return { w: 12, h: 7, minW: 1, maxW: 12, minH: 1, maxH: 7 };
      }
      if (['md', 'sm'].includes(breakpoint)) {
        return { w: 2, h: 6, minW: 1, maxW: 2, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
    default:
      if (['xxl', 'xl', 'lg'].includes(breakpoint)) {
        return { w: 4, h: 3, minW: 1, maxW: 5, minH: 2, maxH: 6 };
      }
      return commonSize(breakpoint, item);
  }
};

export const calculateItemPositions = (widgets, totalWidthOfItems) => {
  const lessThanLG = window.innerWidth < 1024;
  const maxGridWidth = lessThanLG ? 2 : 12;
  const positions = [];
  const grid = Array(100)
    .fill(null)
    .map(() => Array(maxGridWidth).fill(false));
  let maxY = 0;

  const isSpaceAvailable = (x, y, width, height) => {
    if (x + width > maxGridWidth) return false;
    for (let i = y; i < y + height; i++) {
      for (let j = x; j < x + width; j++) {
        if (grid[i] && grid[i][j]) return false;
      }
    }
    return true;
  };

  const findBestPosition = (width, height) => {
    let bestX = 0;
    let bestY = 0;
    let found = false;

    // First try to fill any gaps in existing rows
    for (let y = 0; y <= maxY; y++) {
      for (let x = 0; x < maxGridWidth; x++) {
        if (isSpaceAvailable(x, y, width, height)) {
          // Check if this position connects to existing items
          const hasAdjacentItem =
            (x > 0 && grid[y][x - 1]) || // Left
            (x + width < maxGridWidth && grid[y] && grid[y][x + width]) || // Right
            (y > 0 && grid[y - 1][x]); // Top

          if (hasAdjacentItem) {
            return { x, y };
          }

          if (!found) {
            bestX = x;
            bestY = y;
            found = true;
          }
        }
      }
    }

    // If no gaps found, place at the bottom
    if (!found) {
      bestY = maxY;
      // Try to place it at the leftmost position
      for (let x = 0; x < maxGridWidth; x++) {
        if (isSpaceAvailable(x, maxY, width, height)) {
          bestX = x;
          break;
        }
      }
    }

    return { x: bestX, y: bestY };
  };

  const markOccupiedSpace = (x, y, width, height) => {
    for (let i = y; i < y + height; i++) {
      for (let j = x; j < x + width; j++) {
        if (grid[i]) grid[i][j] = true;
      }
    }
    maxY = Math.max(maxY, y + height);
  };

  if (widgets.length) {
    widgets.forEach((item, i) => {
      const itemWidth = item.w || calcSize(item.size, item).w;
      const itemHeight = item.h || calcSize(item.size, item).h;

      const position = findBestPosition(itemWidth, itemHeight);
      positions.push(position);
      markOccupiedSpace(position.x, position.y, itemWidth, itemHeight);
    });
  }

  return positions;
};
